<template>
    <v-container class="pa-1">
        <div>
            <v-select outlined dense
                class="mt-3"
                :loading="computedIsLoadingRequests"
                label="Contexto de Agendamento"
                :items="computedContextos"
                @change="onChangeContexto"
                return-object
                :disabled="computedSalas.length === 0"
                item-text="descricao">
                <template v-slot:selection="{ item }">
                    <h3>{{item.descricao}}</h3>
                </template>
            </v-select>

            <v-row dense>
                <v-spacer></v-spacer>
                <h2 v-show="!contextoIsSelected">Selecione um Contexto de Agendamento</h2>
                <v-spacer></v-spacer>
            </v-row>

            <v-form accept-charset="utf-8" v-show="contextoIsSelected">
            
            <v-row dense class="pa-2">
                    Solicitante: <span class="subtitle-2 font-weight-black"> {{agenda.solicitante}}</span>
                </v-row>
                <v-row dense>               
                    <!-- TITULO DA PRATICA -->
                    <v-col cols="12" sm="12">
                        <v-text-field outlined dense required v-model="agenda.titulo_aula" autofocus
                            label="Título da prática" 
                            v-validate="{ required: true }"
                            data-vv-as="Título prática"
                            :messages="veeErrors.first('input-titulo-pratica')"
                            data-vv-name="input-titulo-pratica"
                            hour-label="hora" minute-label="minutos"
                            :class="veeErrors.has('input-titulo-pratica') ? 'v-input--has-state error--text' : ''"
                            clearable>
                            <template v-slot:message="{message}">
                                <span class="error--text">{{message}}</span>
                            </template>
                        </v-text-field>
                        
                    </v-col>

                    <!-- TURMA -->
                    <v-col cols="12" sm="6" md="6">
                        <v-combobox clearable hide-selected outlined dense 
                            no-data-text="Nenhum registro"
                            v-model="agenda.codturma"
                            :loading="$store.formularioStore.state.loadingTurmas" 
                            :items="$store.formularioStore.getters.getTurmas" 
                            label="Turma" placeholder="Informe a Turma" 
                            :messages="veeErrors.first('input-codturma')"
                            v-validate="{ required: true }"
                            data-vv-as="Turma"
                            :data-vv-name="'input-codturma'"
                            :class="veeErrors.has('input-codturma') ? 'v-input--has-state error--text' : ''"
                            >
                            <template v-slot:message="{message}">
                                <span class="error--text">{{message}}</span>
                            </template>
                        </v-combobox>
                    </v-col>

                    <!-- CURSO -->
                    <v-col cols="12" sm="6" md="6">
                        <v-combobox clearable hide-selected outlined dense 
                            no-data-text="Nenhum registro"
                            v-model="agenda.curso"
                            :loading="$store.formularioStore.state.loadingCursos" 
                            :items="$store.formularioStore.getters.getCursos" 
                            label="Curso" placeholder="Selecione o curso" 
                            :messages="veeErrors.first('input-curso')"
                            v-validate="{ required: true }"
                            data-vv-as="Curso"
                            :data-vv-name="'input-curso'"
                            :class="veeErrors.has('input-curso') ? 'v-input--has-state error--text' : ''"
                            >
                            <template v-slot:message="{message}">
                                <span class="error--text">{{message}}</span>
                            </template>
                        </v-combobox>
                    </v-col>

                    <!-- DISCIPLINA -->
                    <v-col cols="12" sm="6">
                        <v-combobox clearable hide-selected outlined dense
                            no-data-text="Nenhum registro"
                            v-model="agenda.disciplina"
                            :loading="$store.formularioStore.state.loadingDisciplinas" 
                            :items="$store.formularioStore.getters.getDisciplinas" 
                            label="Disciplina / Unidade" placeholder="Selecione a disciplina/unidade"
                            :messages="veeErrors.first('input-disciplina')"
                            v-validate="{ required: true }"
                            data-vv-as="Disciplina"
                            :data-vv-name="'input-disciplina'"
                            :class="veeErrors.has('input-disciplina') ? 'v-input--has-state error--text' : ''"
                        >
                            <template v-slot:message="{message}">
                                <span class="error--text">{{message}}</span>
                            </template>
                        </v-combobox>
                    </v-col>

                    <!-- FINALIDADE -->
                    <v-col cols="12" sm="6" md="6">
                        <v-autocomplete v-model="agenda.finalidade" outlined dense
                            label="Finalidade" placeholder="Selecione a finalidade"
                            :items="$store.formularioStore.state.finalidades"
                            no-data-text="Nenhuma finalidade disponível"
                            item-value="id"
                            item-text="descricao"
                            :disabled="$store.formularioStore.state.loadingFinalidades" 
                            :loading="$store.formularioStore.state.loadingFinalidades"
                            :messages="veeErrors.first('input-finalidade')"
                            v-validate="{ required: true }"
                            data-vv-as="Finalidade"
                            :data-vv-name="'input-finalidade'"
                            :class="veeErrors.has('input-finalidade') ? 'v-input--has-state error--text' : ''"
                            >
                            <template v-slot:message="{message}">
                                <span class="error--text">{{message}}</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    
                    <!-- LABORATORIO -->
                    <v-col cols="12" sm="6" md="6">
                        <v-autocomplete 
                            @change="onChangeSala"
                            v-model="agenda.sala" outlined dense
                            label="Laboratório / Consultório" placeholder="Selecione o laboratório" 
                            no-data-text="Nenhum registro"
                            :items="computedSalasPorContexto"
                            item-value="id"
                            item-text="sala"
                            :disabled="$store.formularioStore.state.loadingSalas" 
                            :loading="$store.formularioStore.state.loadingSalas"
                            :messages="veeErrors.first('input-sala')"
                            v-validate="{ required: true }"
                            data-vv-as="Sala"
                            :data-vv-name="'input-sala'"
                            :class="veeErrors.has('input-sala') ? 'v-input--has-state error--text' : ''"
                            >
                            <template v-slot:message="{message}">
                                <span class="error--text">{{message}}</span>
                            </template>
                        </v-autocomplete>
                    </v-col>

                    <!-- DATA -->
                    <v-col cols="12" sm="6" md="6">
                        <v-menu v-model="datepickerData" :close-on-content-click="true"
                            :nudge-right="0" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field 
                                    v-model="computedDateFormatted" 
                                    label="Data" outlined dense readonly
                                    prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" placeholder="Data reserva"
                                    :messages="veeErrors.first('input-data')"
                                    v-validate="{ required: true }"
                                    data-vv-as="Data"
                                    :data-vv-name="'input-data'"
                                    :class="veeErrors.has('input-data') ? 'v-input--has-state error--text' : ''">
                                    <template v-slot:message="{message}">
                                        <span class="error--text">{{message}}</span>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker locale="pt-Br" min-width="auto" width="270"
                                v-model="agenda.data"  @input="datepickerData = false" 
                                :allowed-dates="allowedDates">
                            </v-date-picker>
                        </v-menu>
                    </v-col>

                    <!-- HORARIO -->
                    <v-col v-if="false" cols="12" sm="6" md="6">
                        <input type="hidden"
                            dense v-model="agenda.horario" hide-details disabled
                            v-validate="{ required: true }"
                            data-vv-as="Horário"
                            data-vv-name="input-horario"/>
                        <v-autocomplete v-model="horario_selected"
                            @change="onChangeHorario"
                            outlined dense return-object
                            label="Horário" placeholder="Selecione um horário"
                            :items="computedHorariosSalas"
                            item-value="descricao"
                            item-text="descricao"
                            :messages="veeErrors.first('input-horario')"
                            data-vv-as="Horário"
                            :data-vv-name="'input-horario'"
                            :class="veeErrors.has('input-horario') ? 'v-input--has-state error--text' : ''"
                            no-data-text="Nenhum horário disponível"
                            >
                            <template v-slot:message="{message}">
                                <span class="error--text">{{message}}</span>
                            </template>
                        </v-autocomplete>
                    </v-col>

                    <v-col v-if="false" cols="12" sm="6" md="6">
                        <v-text-field 
                            dense outlined :value="agenda.horario ? `${agenda.start} às ${agenda.end}`: ''" hide-details disabled
                            v-validate="{ required: true }"
                            data-vv-as="Horário"
                            data-vv-name="input-horario-text"
                            hour-label="hora" minute-label="minutos"
                            :class="veeErrors.has('input-horario-text') ? 'v-input--has-state error--text' : ''"
                            >
                        </v-text-field>
                    </v-col>

                    <!-- START -->
                    <v-col v-if="true" cols="12" sm="4" md="3">
                        <vue-timepicker v-model="agenda.start" placeholder="Hora início"
                            :hour-range="[[7,21]]" :minute-range="[0, 15, 30, 45]"
                            hide-disabled-items close-on-complete
                            hour-label="hora" minute-label="minutos"
                            v-validate="{ required: true }"
                            data-vv-as="Hora início"
                            data-vv-name="input-start"
                            :class="veeErrors.has('input-start') ? 'is-invalid' : ''">
                            <template v-slot:icon>
                                <v-icon small>mdi-clock-time-eight-outline</v-icon>
                            </template>
                        </vue-timepicker>
                        <div class="v-text-field__details">
                            <div class="v-messages theme--light">
                                <div class="v-messages__wrapper error--text">
                                    {{ veeErrors.first('input-start') }}
                                </div>
                            </div>
                        </div>
                    </v-col>

                    <!-- END -->
                    <v-col v-if="true" cols="12" sm="4" md="3">
                        <vue-timepicker v-model="agenda.end" placeholder="Hora fim"
                            :hour-range="[[7,21]]" :minute-range="[0, 15, 30, 45]"
                            hide-disabled-items close-on-complete
                            v-validate="{ required: true }"
                            data-vv-as="Hora fim"
                            data-vv-name="input-end"
                            hour-label="hora" minute-label="minutos"
                            :class="veeErrors.has('input-end') ? 'is-invalid' : ''">
                            <template v-slot:icon>
                                <v-icon small>mdi-clock-time-eight-outline</v-icon>
                            </template>
                        </vue-timepicker>
                        <div class="v-text-field__details">
                            <div class="v-messages theme--light">
                                <div class="v-messages__wrapper error--text">
                                    {{ veeErrors.first('input-end') }}
                                </div>
                            </div>
                        </div>
                    </v-col>

                    <!-- QUANTIDADE ALUNOS -->
                    <v-col cols="12" sm="4" md="6">
                        <v-text-field type="number" label="Qtde alunos" min="1" v-model="agenda.alunos"
                            data-vv-as="Quantidade" outlined dense>
                            
                            <template v-slot:prepend-inner>
                                <v-btn v-if="$vuetify.breakpoint.mdAndDown" color="error" outlined small icon @click="agenda.alunos<= 1 ? '' :agenda.alunos--">
                                    <v-icon small>mdi-minus</v-icon>
                                </v-btn>
                            </template>
                            <template v-slot:append>
                                <v-btn v-if="$vuetify.breakpoint.mdAndDown" color="success" outlined small icon @click="agenda.alunos++">
                                    <v-icon small>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                    </v-col>
                

                    <!-- ANEXO -->
                    <v-col cols="12" md="12" lg="6">
                        <div class="mb-1">
                            <a :href="(computedContextoSelecionado.get_configuracao||{}).link_protocolo_pratica || '#'" target="_blank">
                                {{(computedContextoSelecionado.get_configuracao||{}).legenda_anexo1 || 'Arquivo'}}
                            </a>
                        </div>
                        <v-file-input outlined dense v-model="agenda.file_protocolo_pratica" hide-details
                            v-validate="{ required: true, onlyPDF: true }"
                            data-vv-as="Arquivo Anexo"
                            data-vv-name="input-file-protocolo-pratica"
                            hour-label="hora" minute-label="minutos"
                            :class="veeErrors.has('input-file-protocolo-pratica') ? 'v-input--has-state error--text' : ''"
                            @change="onProtocoloPraticaSelected"
                            accept="application/pdf"
                            prepend-inner-icon="mdi-paperclip" 
                            label="Anexar Arquivo"
                            color="primary">
                            <template v-slot:selection="{ text }">
                                &nbsp; {{ text|truncate_file_text(10) }}
                                <v-icon>mdi-file</v-icon>
                            </template>
                        </v-file-input>
                        <div class="v-text-field__details">
                            <div class="v-messages theme--light">
                                <div class="v-messages__wrapper error--text">
                                    {{ veeErrors.first('input-file-protocolo-pratica') }}
                                </div>
                            </div>
                        </div>
                    </v-col>

                    <!-- ANEXO 2 -->
                    <v-col cols="12" md="12" lg="6" v-if="false">
                        <div class="mb-1">
                            <a :href="(computedContextoSelecionado.get_configuracao||{}).link_roteiro_solicitacao || '#'" target="_blank">
                                Modelo Solicitação de materiais
                            </a>
                        </div>
                        <v-file-input dense outlined v-model="agenda.file_reagentes_equipamentos" hide-details
                            v-validate="{ required: true, onlyPDF: true }"
                            data-vv-as="Arquivo de Lista de Materiais"
                            data-vv-name="input-file-reagentes-equipamentos"
                            hour-label="hora" minute-label="minutos"
                            :class="veeErrors.has('input-file-reagentes-equipamentos') ? 'v-input--has-state error--text' : ''"
                            @change="onReagentesEquipamentosSelected"
                            accept=".pdf, .doc, .docx"
                            prepend-inner-icon="mdi-paperclip"
                            label="Lista de materiais"
                            color="primary">
                            <template v-slot:selection="{ text }">
                                &nbsp; {{ text|truncate_file_text(10) }}
                                <v-icon>mdi-file</v-icon>
                            </template>
                        </v-file-input>
                        <div class="v-text-field__details">
                            <div class="v-messages theme--light">
                                <div class="v-messages__wrapper error--text">
                                    {{ veeErrors.first('input-file-reagentes-equipamentos') }}
                                </div>
                            </div>
                        </div>
                    </v-col>

                </v-row>
                    

                <v-btn @click.stop="onSubmit" :loading="computedIsLoading" elevation="0" color="primary">
                    <v-icon small class="mr-2">mdi-checkbox-marked-circle-outline</v-icon> Reservar 
                </v-btn>


            </v-form>
            <!-- HORARIO TEXT -->
        </div>
    </v-container>
</template>

<script>
import AuthService from '@/services/authService'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import 'vue2-timepicker/dist/VueTimepicker.css'
import FrontendConfigService from '@/services/configs/frontendConfigService'
export default {
    props:{
        object:{
            required:true
        }
    },
	name: 'Formulario',
	components: {
        VueTimepicker
	},
	data(){
		return {
            datepickerData: false,
            date:null,
            rules:{
                required: [ v => !!v || 'Campo obrigatório' ]
            },
			agenda:{},
            horario_selected:null
		}
	},
	methods:{
        onChangeContexto(contexto){
            // this.setContexto(contexto)
            this.$store.globalStore.commit('setContexto', contexto)
            this.agenda.sala = null
        },
        onChangeSala(){
            //this.horario_selected = null
            //this.agenda.horario = null
            //this.agenda.start = null
            //this.agenda.end = null
        },
        onChangeHorario(value){
            this.agenda.horario = value.descricao
            this.agenda.start = value.inicio
            this.agenda.end = value.fim
        },
        resetForm(){
            this.agenda.file_protocolo_pratica = null
            this.agenda.file_reagentes_equipamentos = null
            this.agenda.data = null
            // this.agenda.start = '10:00'
            // this.agenda.end = '11:00'
            this.agenda.horario = null
            this.horario_selected = null
        },
        onProtocoloPraticaSelected(event){
            this.agenda.file_protocolo_pratica = event 
        },
        onReagentesEquipamentosSelected(event){
            this.agenda.file_reagentes_equipamentos = event 
        },
        formatDate (date) {
            if (!date) return null
            
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        loadResources(){
            setTimeout(()=>{
                    this.$store.formularioStore.dispatch('request_salas')
                    this.$store.formularioStore.dispatch('request_cursos')
                    this.$store.formularioStore.dispatch('request_disciplinas')
                    this.$store.formularioStore.dispatch('request_finalidades')
                    this.$store.formularioStore.dispatch('request_turmas')
                    // this.$store.globalStore.dispatch('request_settings')
                }
                ,1500
            );
        },
        validateTimes(){
            if(this.agenda.start && this.agenda.end){
                const splitstart = this.agenda.start.split(':')
                const splitend = this.agenda.end.split(':')
                try{
                    if(splitstart[1] === 'mm') {
                        alert('Horário inicial inválido')
                        return false
                    }
                    if(splitend[1] === 'mm') {
                        alert('Horário final inválido')
                        return false
                    }
                    if(splitend[0] < splitstart[0]) {
                        alert('Hora final não pode ser inferior à inicial')
                        return false
                    }

                }catch(ex){
                    console.error(ex)
                    return false
                }
            }else{
                alert('Horário inicial e/ou final não informados!')
                return false
            }
            return true
        },
        limparErrors(){
            this.veeErrors.clear()
        },
        veeValidateField(ref) {
            if ( this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        onSubmit(){
            this.$validator.validateAll()
                .then(success => {
                    // vuetify rules Validation
                    // vee Validation
                    if (!success || !this.validateTimes()) {
                        return;
                    }
                    //cria objeto do tipo FormData que passa para a requisição
                    var fd = new FormData();
                    //adiciona atributo foto ao objeto
                    if (this.agenda.file_protocolo_pratica)
                        fd.append('file_protocolo_pratica',this.agenda.file_protocolo_pratica, this.agenda.file_protocolo_pratica.name)
                    
                    if (this.agenda.file_reagentes_equipamentos)
                        fd.append('file_reagentes_equipamentos',this.agenda.file_reagentes_equipamentos, this.agenda.file_reagentes_equipamentos.name)
                    
                    //adiciona atributo userId ao objeto que, no backend, é uma referencia para o usuario logado,
                    //portanto o avatar a ser alterado neste componente será sempre o próprio usuário

                    fd.append('solicitante', this.agenda.solicitante)
                    fd.append('codturma', this.agenda.codturma)
                    fd.append('curso', this.agenda.curso)
                    fd.append('disciplina', this.agenda.disciplina)
                    fd.append('sala', this.agenda.sala)
                    fd.append('finalidade', this.agenda.finalidade)
                    fd.append('titulo_aula', this.agenda.titulo_aula)
                    fd.append('data', this.agenda.data)
                    fd.append('start', this.agenda.start)
                    fd.append('end', this.agenda.end)
                    fd.append('alunos', this.agenda.alunos)
                    fd.append('horario', this.agenda.horario)
                    
                    const request = this.$store.formularioStore.dispatch('create_agenda', {agenda:fd}) //, headers: headers})
                    this.$store.formularioStore.commit('setLoading', true)
                    request.then( () => { 
                        this.$store.formularioStore.commit('setNotifications', [
                                { 
                                    'tag':'success', 
                                    'title':'Nova Reserva', 
                                    'message':`Reserva criada com sucesso!`
                                }
                            ])
                            //this.agenda = Object.assign({}, this.object)
                            this.resetForm()
                            
                            
                        }).catch( error => { 
                            //console.error('Error:',error.response); 
                            this.$store.formularioStore.dispatch('tryError', error) 
                        }).finally( () => { 
                            this.$store.formularioStore.commit('setLoading', false) 
                            this.limparErrors()
                        })
                })
                .catch( error => {
                    console.log('Error onSubmit: ', error)  
                });
        },
        getSolicitante(){
            const solicitante = AuthService.obterUsuarioAutenticado()
            if(solicitante && solicitante.username){
                this.agenda.solicitante = `${solicitante.first_name} ${solicitante.last_name}`
            }
            return solicitante
        },
        allowedDates(val){
            let hj =  new Date();
            hj.setDate(hj.getDate()-1);
            // Exibir somente datas futuras, incluindo hj
            return new Date(val) > hj 
        },
        
    },
    computed:{
        computedHorariosSalas(){
            let salas = this.$store.formularioStore.state.salas
            let horarios = salas.filter( obj=> obj.id == this.agenda.sala)
            return horarios.length > 0 ? horarios[0].get_horarios : horarios
        },
        computedIsLoading(){
            let isloading = this.$store.formularioStore.getters.isLoading
            return isloading
        },
        computedIsLoadingRequests(){
            let isloading = this.$store.formularioStore.getters.isLoadingRequests
            return isloading
        },
        computedProtocoloPratica(){
            return 'https://f1.pngfuel.com/png/933/945/137/social-media-icons-background-avatar-user-profile-login-black-circle-silhouette-symbol-png-clip-art.png'
        },
        computedDateFormatted () {
            return this.formatDate(this.agenda.data)
        },
        computedSalasPorContexto(){
            try{
                return this.computedSalas.filter(s => s.contexto === this.computedContextoSelecionado.id)
            }catch{
                return []
            }
        },
        computedSalas(){
            return this.$store.formularioStore.state.salas
        },
        computedFinalidades(){
            return this.$store.formularioStore.getters.getFinalidades
        },
        computedLoadingFinalidades(){
            return this.$store.formularioStore.getters.getLoadingFinalidades
        },
        computedNotifications(){
            return this.$store.formularioStore.getters.getNotifications
        },
        computedContextos(){
            const contextos = this.computedSalas.map(sala => sala.get_contexto)
            return contextos.filter((obj, index, self) =>
                index === self.findIndex((el) => el['id'] === obj['id'])
            )
        },
        computedContextoSelecionado(){
            return this.$store.globalStore.getters.getContexto
        },
        contextoIsSelected(){
            return this.computedContextoSelecionado && this.computedContextoSelecionado.id
        }
    },
    created(){
        this.agenda = Object.assign({}, this.object)

        this.$validator.extend('maiorQzero', {
            getMessage: field =>  field + ' deve ser maior que zero',
            validate: (value) => {
                // value must be > zero
                if (value > 0 ) 
                    return true;
                return false;
            }
        });

        this.$validator.extend('onlyPDF', {
            getMessage: field =>  field + ' deve ser PDF',
            validate: (value) => {
                // value must be PDF
                if (value.name.toLowerCase().indexOf('.pdf') == value.name.toLowerCase().trim().length-4) 
                    return true;
                return false;
            }
        });
    },
    mounted(){
        this.loadResources()
        this.getSolicitante()
    },
    watch:{
        computedNotifications:{
            handler(errors){
                for(let message of errors){
                    let options = FrontendConfigService.getOptionsToast()
                    //console.log(`${message.tag} - ${message.message} ${message.title}- ${options}`);
                    this.$toast(message.message, {
                        type: message.tag,
                        ...options
                    })
                }
            }, deep:true
        },
    }
}
</script>

<style>
.vue__time-picker input.display-time{
    height: 40px;
    border: 1px solid #aaa;
    border-radius: 4px;
    width: 100%;    
    font-size: 16px;
    /*padding-left: 60px;*/
}
.vue__time-picker{
    width: 100%;    
}
.v-file-input .v-input__prepend-outer{
    display: none;
}
.vue__time-picker input.display-time:hover{
    border-color: #000;
}
</style>